import moment from 'moment'

moment.updateLocale('en', {
  week: {
    dow: 1
  }
})

export const dayOfTheWeek = [...Array(7)].map((_, i) => ({
  label: moment().weekday(i).format('dddd'),
  value: moment().day(i).format('d')
}))

export const bookingLunchFromTimeValues = [5, 6, 7, 8, 9, 10, 11, 12]
export const bookingLunchToTimeValues = [12, 13, 14, 15, 16]
export const bookingDinnerFromTimeValues = [17, 18, 19]
export const bookingDinnerToTimeValues = [20, 21, 22, 23, 0]
